/** 成功Code，对应原先的200 */
export const SUCCESS_CODE = '00000';

/** 需要跳转到登录页的错误Code列表 */
export enum ERROR_CODE_MAP {
  /** 权限异常Code，对应原先的401 */
  A0300 = 'A0300',
}
